import { useNavigate } from '@tanstack/react-router';
import { H2, YStack } from 'tamagui';
import { StoresContent } from '@mrrmlab/feature-lists';

export function EinstellungenGeschaefteRoute() {
  const navigate = useNavigate();
  return (
    <YStack padding="$4" gap="$3" maxWidth={640}>
      <H2>Geschäfte</H2>
      <StoresContent
        onCatalogPress={(storeId) =>
          navigate({ to: '/einstellungen/geschaefte/$storeId/catalog', params: { storeId } })
        }
      />
    </YStack>
  );
}
